import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import util from 'util/Util.js';
import textUtil from 'util/TextUtil.js';
import { View } from 'backbone';

import templateNumber from 'report/properties/formats/number.ejs';
import templateDate from 'report/properties/formats/date.ejs';
import templateTime from 'report/properties/formats/time.ejs';
import templateBoolean from 'report/properties/formats/boolean.ejs';
import templatePercentage from 'report/properties/formats/percentage.ejs';


class FormatView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = function(){return ''};
        this.tagName = 'div';
        this.config = opts.config || {};

        return this;
    }

    chooseTemplate(formatName){
        var templateMap = {
            'none': function(){return ''},
            'number': templateNumber,
            'date': templateDate,
            'time': templateTime,
            'boolean': templateBoolean,
            'percentage': templatePercentage
        }
        this.template = templateMap[formatName];
    }

    prepareData(formatName){
        let formatOption = this.model.get('columnFormatOption');
        let options = formatOption? formatOption.split('|') : null;
        if (options) {
            switch (formatName) {
                case 'number':
                    this.model.set('numberDecimals', options[0], {silent: true});
                    this.model.set('numberDecimalSeparator', textUtil.convertSymbolToText(options[1]), {silent: true});
                    this.model.set('numberThousandSeparator', textUtil.convertSymbolToText(options[2]), {silent: true});
                    this.model.set('numberSymbol', options[3], {silent: true});
                    break;
                case 'date':
                    this.model.set('dateFormat', options[0], {silent: true});
                    break;
                case 'time':
                    this.model.set('time24Hour', util.isTrue(options[0])? 'checked': '', {silent: true});
                    this.model.set('timeShowSeconds', util.isTrue(options[1])? 'checked': '', {silent: true});
                    break;
                case 'boolean':
                    this.model.set('booleanYes', options[0], {silent: true});
                    this.model.set('booleanNo', options[1], {silent: true});
                    break;
                case 'percentage':
                    this.model.set('percentageDecimals', options[0], {silent: true});
                    break;
                default: break;
            }
        }
    }

    updateSelectField(formatName){
        switch (formatName) {
            case 'number':
                $("#numberDecimalSeparator option[value='" +
                    this.model.get('numberDecimalSeparator') + "']").prop('selected', true);
                $("#numberThousandSeparator option[value='" +
                    this.model.get('numberThousandSeparator')+ "']").prop('selected', true);
                break;
            case 'date':
                $("#dateFormat option[value='" + this.model.get('dateFormat') + "']").prop('selected', true);
                break;
            case 'time':
                $("#time24Hour").prop("checked", this.model.get('time24Hour')==='checked' );
                $("#timeShowSeconds").prop("checked",  this.model.get('timeShowSeconds')==='checked' );
                break;
            case 'percentage': break;
            default: break;
        }
    }

    render() {
        let formatName = this.model.get('columnFormat')? this.model.get('columnFormat') : 'none';
        this.chooseTemplate(formatName);
        this.prepareData(formatName);
        this.$el.html(this.template(this.model.toJSON()));
        this.updateSelectField(formatName);
        return this;
    }

}

export default FormatView;